<script>

import Hamburger from './hamburger'
import DeckStyles from './decks'
import BackStyles from './backs'

import Deck from './deck.vue'

export default {
  components: { Deck, Hamburger },
  data() {

    return {
      deckTheme: localStorage.getItem('deckTheme') || 'ulassa',
      backTheme: localStorage.getItem('backTheme') || 'home',
      showHamburger: true,
      background: localStorage.getItem('background') || 'light'
    }
  },
  computed: {
    decks() {
      return DeckStyles
    },
    backs() {
      return BackStyles
    }
  },
  watch: {
    deckTheme() {
      localStorage.setItem('deckTheme', this.deckTheme)
    },
    backTheme() {
      localStorage.setItem('backTheme', this.backTheme)
    },
    background: {
      immediate: true,
      handler() {
        localStorage.setItem('background', this.background)
        if (this.background == 'light') {
          document.body.classList.remove('dark')
        } else {
          document.body.classList.add('dark')
        }
      }
    }
  }
}
</script>

<template>
  <div>
    <hamburger v-if="showHamburger">
      <h2>Deck</h2>
      <ul>
        <li v-for="(deck, key) in decks" :key="key">
          <label>
            <input type="radio" name="deck" v-model="deckTheme" :value="key">
            {{ deck.name }}
          </label>
        </li>
      </ul>

      <h2>Back</h2>
      <ul>
        <li v-for="(back, key) in backs" :key="key">
          <label>
            <input type="radio" name="back" v-model="backTheme" :value="key">
            {{ back.name }}
          </label>
        </li>
      </ul>

      <h2>Background</h2>
      <ul>
        <li>
          <label>
            <input type="radio" name="background" v-model="background" value="light"> Light
          </label>
        </li>
        <li>
          <label>
            <input type="radio" name="background" v-model="background" value="dark"> Dark
          </label>
        </li>
      </ul>

    </hamburger>
    <deck :theme="deckTheme" :backTheme="backTheme" @select="showHamburger = !$event"></deck>
  </div>
</template>

<style lang="scss">
h2 {
  margin-top: 0;
  margin-bottom: 0;
}
ul {
  padding: 0;
  margin-bottom: 50px;
  margin-top: 0;
}
li {
  font-size: 22px;
  line-height: 35px;
  list-style-type: none;
  padding: 5px;
}
</style>
